import { render, staticRenderFns } from "./WonderAiReport.vue?vue&type=template&id=c63b86e8&scoped=true"
import script from "./WonderAiReport.vue?vue&type=script&lang=js"
export * from "./WonderAiReport.vue?vue&type=script&lang=js"
import style0 from "./WonderAiReport.vue?vue&type=style&index=0&id=c63b86e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63b86e8",
  null
  
)

export default component.exports